export default __webpack_public_path__ + "static/media/rawsturgeon.f44706c1.PNG";